<svg (click)="clicked()">
    <use [attr.xlink:href]="icono|iconoRef"></use>
</svg>
